export default {
    'header.login': 'Login',
    'header.register': 'Register',
};